import { Button } from 'primereact/button';
import React from 'react';

import { MenuVariantElementProps } from '../use-tool-bar';

export const historyMenuSmall = ({ hook }: MenuVariantElementProps) => {
  const values = hook();
  if (values?.type == 'node-history') {
    const {
      actions: { undo, redo, undoSelectable, redoSelectable },
    } = values;

    return (
      <>
        <div style={{ gridColumn: '1 / 2', gridRow: '1 / 2' }}>
          <Button
            onClick={() => undo()}
            className="p-button-text"
            disabled={!undoSelectable}
            icon="pi ri-arrow-go-back-line"
          />
        </div>
        <div style={{ gridColumn: '1 / 2', gridRow: '2 / 3' }}>
          <Button
            onClick={() => redo()}
            className="p-button-text"
            disabled={!redoSelectable}
            icon="pi ri-arrow-go-forward-line"
          />
        </div>
      </>
    );
  }
  throw new Error('Unknown or missing hook or hook type.');
};
